import { FeatureFlagAction } from "./action";

type FETCH_STATUS = "idle" | "pending" | "complete" | "error";

type FeatureFlagReducerState = {
  omniStreamlined: string;
  pepPromotionFlag?: string;
  fetchState: FETCH_STATUS;
  error: any;
};

const initialState: FeatureFlagReducerState = {
  omniStreamlined: "",
  pepPromotionFlag: "",
  fetchState: "idle",
  error: undefined,
};

export const FeatureFlagReducer = (state = initialState, action: FeatureFlagAction): FeatureFlagReducerState => {
  switch (action.type) {
    case "@@FeatureFlags/LOAD_FEATURE_FLAG":
      return { ...state, fetchState: "pending" };
    case "@@FeatureFlags/LOAD_FEATURE_FLAG_SUCCESS":
      return { ...state, ...action.payload, fetchState: "complete" };
    case "@@FeatureFlags/LOAD_FEATURE_FLAG_FAILED":
      return { ...state, fetchState: "error", error: action.payload, omniStreamlined: "", pepPromotionFlag: "" };
    default:
      return state;
  }
};
